import { Colors } from "src/styles/DesignSystem";
import styled from "styled-components";

export const Container = styled.section`
    width: 65%;

    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 85%;
    }   
`;

export const Title = styled.h2`
    width: 25%;
    font: 1.75rem/1.25 'Titan One',arial,sans-serif;
    color: ${Colors.brown};

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 100%;
    }  
`;

export const Idea = styled.p`
    width: 60%;
    font: .85rem/1.2 'Varela Round',arial,sans-serif;
    color: ${Colors.grey};

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 100%;
        margin-top: 15px;
    } 
`;

export const ContainerFluid = styled.section`
    width: 100%;
    border-radius: 15px;   
    margin: 10% 0;
    background-color: ${Colors.lighBrown};
    padding-bottom: 25%;

    display: flex;
    flex-direction: column;
    
`;

export const Images = styled.figure`
    width: 100%;
    
    padding: 10% 5%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    img{
        border-radius: 25px;
        &:first-child{
            margin-top: -25%;
        }
        &:nth-child(2){
            margin-top: 0;
        }
        &:nth-child(3){
            margin-top: -30%;
        }
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        flex-direction: column;
        img{
            width: 85%;
            &:not(:first-child){
                margin-top: 10%;
            }
        }
    } 
`;

export const Text = styled.section`
    width: 65%;
    margin: 0 auto;
    text-align: center;
    
    font: 1rem/1.25 'Varela Round',arial,sans-serif;
    color: ${Colors.grey};

    @media screen and (max-width: 480px){
        width: 85%;
        text-align: left;
    }
`;

